import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { getAllParams, replaceParam } from '@core/utilities/utilities.constants';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FieldType } from '@ngx-formly/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'formly-parsed-template',
  template: `<div>
    <div class="d-inline" [ngClass]="props.class" [innerHtml]="template" [attr.id]="props.id"></div>&nbsp;
    <fa-icon
      *ngIf="props.icon"
      pTooltip="{{props.icon?.text | translate}}"
      tooltipPosition="{{props.icon?.tooltipPosition ? props.icon?.tooltipPosition : 'top'}}"
      [icon]="props.icon?.iconProp ? props.icon.iconProp : ['fas', 'info-circle']">
    </fa-icon>
  </div>`,
  imports: [CommonModule, TranslateModule, FontAwesomeModule, TooltipModule],
})
export class CustomFormlyTemplateTypeComponent extends FieldType implements OnInit, OnDestroy {

  private innerHtml = { content: null, template: null };
   private _destroy$ = new Subject<any>();

  constructor(
    private translateService: TranslateService,
    private sanitizer: DomSanitizer,
    private changeDet: ChangeDetectorRef) {
    super();
  }
  
  ngOnInit(): void {
    this.translateService.onLangChange
    .pipe(takeUntil(this._destroy$))
    .subscribe(()=>{
      this.changeDet.detectChanges();
    })
  }

  private getFieldValue(prop) {
    return this.field.model[prop] || '';
  }

  get template() {
    if (this.props.template) {
      let template = this.props.template;
      if (this.props.translate) {
        template = this.translateService.instant(this.props.template);
      }

      const params = getAllParams(template);

      params.forEach(param => {
        template = replaceParam(template, param, this.getFieldValue(param));
      });

      this.innerHtml = {
        template,
        content: this.props.safeHtml ? this.sanitizer.bypassSecurityTrustHtml(template) : template,
      };
    }
    return this.innerHtml.content;
  }

  ngOnDestroy(): void {
    this._destroy$.next(null);
    this._destroy$.complete();
  }
}
